import { HttpInterceptorFn } from '@angular/common/http';


/**
 * Intercepts all HTTP requests and attatches the Language header.
 * @author Brayan Cataño
 */

export const languageInterceptor: HttpInterceptorFn = (req, next) => {
  const language = localStorage.getItem('locale') || 'en';
  const clonedRequest = req.clone({
    headers: req.headers
      .set('Accept-Language', language)
      .set('Content-Language', req.headers.get('Content-Language') || language)
  });
  return next(clonedRequest);
};
